import { IDropDown } from "../Interfaces";
import { CaseStateOptions } from "./CaseStateOptions";

/**
 * @constant
 * @description - The constants holding the case dropdown values
 * @type {IDropDown<CaseStateOptions>[]} - Case State options
 */
export const CASE_STATE_DROP_DOWN: IDropDown<CaseStateOptions>[] = [
  {
    label: "COMMON.ALL",
    value: CaseStateOptions.ALL,
  },
  {
    label: "US.COLLECTION.TRANSACTIONS:CASES_AND_SUBCASES.OPEN",
    value: CaseStateOptions.OPEN,
  },
  {
    label: "US.COLLECTION.TRANSACTIONS:CASES_AND_SUBCASES.CLOSED",
    value: CaseStateOptions.CLOSED,
  },
];
